<div class="faqs-container">
  <div class="box" *ngFor="let faq of faqs" (click)="expand(faq)" [ngClass]="{'show': !faq.isHidden}">
    <div class="question" [innerHTML]="faq.question | i18n"></div>
    <img [src]="faq.isHidden ? '/assets/images/faqs/plus-icon.svg' : '/assets/images/faqs/minus-icon.svg'"
      alt="Plus icon" [alt]="faq.isHidden ? 'Plus icon' : 'Minus icon'"
      class="icon" [ngClass]="{'rotate': !faq.isHidden, 'reverse': faq.isHidden}">
    <div class="description" [innerHTML]="faq.answer | i18n" [ngClass]="{'show': !faq.isHidden, 'hide': faq.isHidden}"></div>
  </div>
  <button class="more" [innerHTML]="'faqs_Data9' |i18n" [routerLink]="'/' + getRouterLink('Contact')"></button>
</div>
